import { Injectable } from '@angular/core';
import { CustomerProjectPhase } from '../../customer-project-phase.interface';
import { CustomerProject } from '../../customer-project.interface';
import { ApiService } from '../api/api.service';

@Injectable({
    providedIn: 'root',
})
export class CustomerProjectPhaseService {
    constructor(private apiService: ApiService) {}

    setActive(project_id, customer_projectphase_id) {
        return this.apiService.postCall$<CustomerProject>(`customer-projects/phases/active`, {
            project_id,
            customer_projectphase_id,
        });
    }

    setDone(customer_projectphase_id, done?: boolean) {
        return this.apiService.postCall$<CustomerProject>(`customer-projects/phases/done`, {
            customer_projectphase_id,
            done,
        });
    }

    savePhase(phase: CustomerProjectPhase) {
        return this.apiService.postCall$<CustomerProjectPhase>(`customer-projects/phases`, phase);
    }

    deletePhase(id: number) {
        return this.apiService.deleteCall$<CustomerProjectPhase>(`customer-projects/phases/${id}`);
    }

    updatePhaseOrder(phases: CustomerProjectPhase[], projectId?: number) {
        return this.apiService.postCall$<CustomerProjectPhase[]>('customer-projects/phases/order', {
            phases: phases.map((phase, index) => {
                return { id: phase.id, order: index };
            }),
            projectId,
        });
    }
}
